import * as tg from "generic-type-guard";

import { Activity } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { isObjectOf } from "../../utilities/typeGuardUtils";

export const isStammdatenRoot = new tg.IsInterface()
	.withProperties({
		stammdatenDefault: new tg.IsInterface()
			.withOptionalProperties({
				erstelltVon: tg.isString,
				bearbeitetVon: tg.isString,
				vorgangsInfo: new tg.IsInterface()
					.withProperties({
						status: tg.isString
					})
					.withOptionalProperties({
						vorgangsnummer: tg.isString
					})
					.get(),
				stammdatenMetadata: new tg.IsInterface()
					.withOptionalProperties({
						isAutomaticallyCreated: tg.isBoolean,
						isEditingAllowed: tg.isBoolean,
						key: tg.isString,
						client: tg.isString,
						fqn: tg.isString
					})
					.get()
			})
			.get()
	})
	.get();

export const isStammdatenDocument = isObjectOf<StammdatenDocument>({
	root: isStammdatenRoot
});
export type StammdatenDocument = Activity.Data.Document & { root: StammdatenRoot };
export type StammdatenRoot = tg.GuardedType<typeof isStammdatenRoot>;
